export default __webpack_public_path__ + "static/media/four.4edf5452.svg";